import AuthService from '@/store/services/auth.service.js'

export default {
  namespaced: true,
  state: {
    authenticated: false,
    APP_KEY: 'jWB69xx8eX7bZNAKPZ2ytqF5J55iFZyMC3wjIhyn',
    APP_SECRET: '6heFHcpX0GjP2DsCBM9DjV7L6SWkJR96fiLRlIsg61bq8XFI3jJAA2cyaz9RMWem7uTD54XpaX5eaSiah0Xeddv2HptAJ4s71i8xM1wONysbhQEwvoCnQKofBdrEdWu4'
  },
  getters: {
    getAuthenticated: state => state.authenticated,
    getAppKey: state => state.APP_KEY,
    getAppSecret: state => state.APP_SECRET
  },
  mutations: {
    SET_AUTHENTICATED (state, status) {
      state.authenticated = status;
    }
  },
  actions: {
    getAccessToken ({ getters, dispatch }, payload) {
      console.log('auth::getAccessToken()', payload)
      const data = {
        'client_id': getters.getAppKey,
        'client_secret': getters.getAppSecret,
        'grant_type': 'password',
        'username': payload.username,
        'password': payload.password,
        'scope': 'write'
      }
      return AuthService.getAccesToken(data).then((response) => {
        // TODO store user data
        // if no company_id redirect to create company

        dispatch('setTokens', response.data)
        dispatch('setUserData', response.data)
        return response
      })
    },
    async refreshToken({ getters, dispatch }) {
      const data = {
        client_id: getters['getAppKey'],
        client_secret: getters['getAppSecret'],
        grant_type: 'refresh_token',
        refresh_token: localStorage.getItem('refresh_token'),
        scope: 'write',
      }
  
      try {
        const response = await AuthService.getAccesToken(data)
        await dispatch('setTokens', response.data)
        return response.data.access_token
      } catch (error) {
        console.log('refreshToken unauthenticate', error)
        await dispatch('unauthenticate')
        throw error // Re-throw the error to handle it in the interceptor
      }
    },
    mobileLogin ({ commit, dispatch }, payload) {
      // this function is used only by mobile, set mobile view to true
      localStorage.setItem('mobile_app_view', payload.mobile_app_view)
      commit('main/SET_MOBILE_APP_VIEW', true, { root: true })
      dispatch('setTokens', payload)
      dispatch('setUserData', payload)
    },
    setUserData ({ dispatch }, payload) {
      console.log('auth::setUserData()', payload)
      // Save user data to local storage
      localStorage.setItem('user_id', payload.user_id)
      localStorage.setItem('company_id', payload.company)
      if (payload.is_staff) {
        localStorage.setItem('is_staff', payload.is_staff)
      }
      dispatch('main/setUserData', payload, { root: true })
    },
    setTokens (_, payload) {
      // console.log('auth::setTokens()', payload)
      // Save the access_token and refresh_token in localStorage
      localStorage.setItem('access_token', payload.access_token)
      localStorage.setItem('refresh_token', payload.refresh_token)
    },
    checkAuth ({ dispatch }) {
      console.log('auth::checkAuth()')
      const access_token = localStorage.getItem('access_token')
      const refresh_token = localStorage.getItem('refresh_token')
      const user_id = localStorage.getItem('user_id')
      const company_id = localStorage.getItem('company_id')
      const mobile_app_view = localStorage.getItem('mobile_app_view')
      const is_staff = localStorage.getItem('is_staff')

      // TODO if not company_id redirect to company creation view (?)

      if (access_token?.trim() && access_token !== 'undefined' &&
          refresh_token?.trim() && refresh_token !== 'undefined' &&
          user_id?.trim() && user_id !== 'undefined' &&
          company_id?.trim() && company_id !== 'undefined') {
        if (mobile_app_view) {
          dispatch('main/setMobileAppView', true, { root: true })
        }
        const user_data = { user_id: user_id, company_id: company_id }
        if (is_staff) {
          user_data.is_staff = is_staff
        }
        dispatch('main/setUserData', user_data, { root: true })
        dispatch('authenticate')
      } else {
        console.log('checkAuth unauthenticate')
        dispatch('unauthenticate')
      }
    },
    authenticate ({ commit }) {
      console.log('auth::authenticate()')
      commit('SET_AUTHENTICATED', true)
    },
    unauthenticate ({ commit, dispatch }) {
      console.log('auth::unauthenticate()')
      dispatch('clearStorage')
      commit('SET_AUTHENTICATED', false)
    },
    logout ({ dispatch }, language) {
      console.log('auth::logout()', language)
      dispatch('clearStorage')
      window.location.href = '/' + language + '/accounts/login/'
    },
    clearStorage () {
      const storageKeys = [
        'user_id',
        'company_id',
        'access_token',
        'refresh_token',
        'mobile_app_view',
        'is_staff'
      ]
      storageKeys.forEach(key => {
        localStorage.removeItem(key)
      })
    },
    getResetLink (_, payload) {
      return AuthService.getResetLink(payload).then((response) => {
        return response
      })
    },
    resetPassword (_, payload) {
      return AuthService.resetPassword(payload).then((response) => {
        return response
      })
    },
  }
}
